import { createAction } from '@reduxjs/toolkit';
export const HANDLE_CALL_NOTIFICATION = 'HANDLE_CALL_NOTIFICATION';
export const handleCallNotificationAction = createAction(HANDLE_CALL_NOTIFICATION);